var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelpCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 9.48245C9.375 9.48245 9.41438 8.66214 10.2923 7.95574C10.8131 7.53621 11.4375 7.4148 12 7.40636C12.5123 7.3998 12.9698 7.48464 13.2436 7.61495C13.6072 7.78804 14.625 8.38277 14.625 9.54105C14.625 10.7598 13.8281 11.3134 12.9202 11.9223C12.0122 12.5312 11.7656 13.1921 11.7656 13.8751",
    stroke: "#3C00CF",
    strokeWidth: 1.3125,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.75012C10.3683 3.75012 8.77325 4.23398 7.41655 5.1405C6.05984 6.04702 5.00242 7.33549 4.378 8.84298C3.75357 10.3505 3.5902 12.0093 3.90853 13.6096C4.22685 15.21 5.01259 16.68 6.16637 17.8338C7.32016 18.9875 8.79017 19.7733 10.3905 20.0916C11.9909 20.4099 13.6497 20.2466 15.1571 19.6221C16.6646 18.9977 17.9531 17.9403 18.8596 16.5836C19.7662 15.2269 20.25 13.6318 20.25 12.0001C20.25 9.81209 19.3808 7.71367 17.8336 6.16649C16.2865 4.61932 14.188 3.75012 12 3.75012Z",
    stroke: "#3C00CF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7188 17.2501C12.2365 17.2501 12.6562 16.8304 12.6562 16.3126C12.6562 15.7949 12.2365 15.3751 11.7188 15.3751C11.201 15.3751 10.7812 15.7949 10.7812 16.3126C10.7812 16.8304 11.201 17.2501 11.7188 17.2501Z",
    fill: "#3C00CF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCircle);
export default __webpack_public_path__ + "static/media/help-circle.a4293f2a40058099f08a74f78a4cf444.svg";
export { ForwardRef as ReactComponent };